import commonApi from './CommonApi.js';

export default {
	getByAnnexId: async (parameters) => {
		return await commonApi().get('/construction-services/by-annex-id', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getById: async (parameters) => {
		return await commonApi().get('/construction-services/id', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	save: async (viewModel) => {
		return await commonApi().post('/construction-services', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	}

}